import { PopoverClassKey, StyleRules } from '@material-ui/core';

const MuiPopover: Partial<StyleRules<PopoverClassKey, {}>> = {
  root: {
    // zIndex: 1400,
  },
};

export default MuiPopover;
